.pageTitle {
  font-size: var(--ism-font-size-heading-2xl);
}

/* Bump heading font size in the component rather than globally on the token  */
@media (--ism-breakpoint-md) {
  .pageTitle {
    font-size: var(--ism-font-size-heading-3xl);
  }
}
